/* eslint-disable import/no-cycle */
import { useCallback, useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import { axios } from '../api/axios';
import { LOCAL_STORAGE_TYPES } from '../constants';
import { UserContainer } from '../providers';
import { useSignOut } from './api/auth';

const useAddonRedirect = () => {
  const [isAlreadyLogin, setIsAlreadyLogin] = useState<boolean>(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState<boolean>(false);
  const { state: userState } = UserContainer.useContainer();

  const location = useLocation();
  const signOut = useSignOut();

  const accessToken = () => {
    return new Cookies().get('accessToken');
  };

  const closeWindow = useCallback(
    (token: string) => {
      const addonData = localStorage.getItem(LOCAL_STORAGE_TYPES.ADDON) ?? '{}';
      const {
        redirectUri = window.location.origin,
        state = null,
        responseType = null,
      } = addonData
        ? JSON.parse(addonData)
        : {
            redirectUri: userState.redirectURL || window.location.origin,
            state: null,
            responseType: null,
          };
      const params = [
        'success=1',
        `response_type=${responseType}`,
        `state=${state}`,
        `code=${token}`,
      ];
      setTimeout(() => {
        window.location.replace(`${redirectUri}?${params.join('&')}`);
      }, 1000);
    },
    [userState?.redirectURL]
  );

  const checkAddonLogin = useCallback(
    async (token?: string) => {
      const userAccessToken = accessToken() ?? token;
      if (userAccessToken) {
        setIsCheckingAuth(true);
        try {
          const { data } = await axios.post('/token', {
            code: userAccessToken,
          });
          if (data.error) {
            setIsAlreadyLogin(false);
            setIsCheckingAuth(false);
            signOut();
          } else {
            // Keep loading state true while redirecting
            closeWindow(userAccessToken);
          }
        } catch (error) {
          setIsCheckingAuth(false);
          setIsAlreadyLogin(false);
          signOut();
        }
      } else {
        // No token, user needs to login - don't show loader
        setIsCheckingAuth(false);
      }
    },
    [closeWindow, signOut]
  );

  useEffect(() => {
    if (location.pathname === '/addon/login') {
      checkAddonLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    checkAddonLogin,
    accessToken,
    isAlreadyLogin,
    setIsAlreadyLogin,
    isCheckingAuth,
  };
};

export default useAddonRedirect;
